import { useMemo } from "react";
import { Surface } from "./surface";
import { TextBody } from "./text";
import { MarginProps } from "./box";

type Props = MarginProps & {
  errors: Record<string, string>;
};

export function Errors({ errors, ...rest }: Props) {
  // Vars
  const errorMessages = useMemo(() => {
    return Object.values(errors);
  }, [errors]);

  // Render
  return (
    <Surface {...rest} variant="error">
      {errorMessages.map((error) => (
        <TextBody key={error} small color="onError">
          {error}
        </TextBody>
      ))}
    </Surface>
  );
}
